import { skipToken, useQuery } from '@tanstack/react-query';
import { ApiError } from '@api/client';
import { bundlesQueryKeys, getBundle } from '@api/bundles';

export function useBundle(id: number | null) {
  return useQuery({
    queryKey: [...bundlesQueryKeys.details(), id],
    queryFn: id === null ? skipToken : () => getBundle(id),
    staleTime: 30_000,
    select: (data) => data.bundle,
    retry: (failureCount, error) =>
      !(error instanceof ApiError && error.status >= 400 && error.status < 500) && failureCount < 3,
  });
}
